// @mui

import { CSSProperties } from 'react';

// ----------------------------------------------------------------------

function SideBarVideogalleryIcon({
  color = '#919EAB',
  style,
}: {
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <svg
      width="26"
      height="33"
      viewBox="0 0 26 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M8.18799 23.3425V17.2351C8.18799 16.2129 9.26367 15.5481 10.1779 16.0052L16.2854 19.0589C17.2988 19.5657 17.2988 21.0119 16.2854 21.5186L10.1779 24.5723C9.26367 25.0295 8.18799 24.3647 8.18799 23.3425Z"
        stroke={color}
        strokeWidth="2.3"
      />
      <path
        d="M13.4699 1.15002H3.8999C2.38112 1.15002 1.1499 2.38124 1.1499 3.90003V28.32C1.1499 29.8388 2.38112 31.07 3.8999 31.07H21.2799C22.7987 31.07 24.0299 29.8388 24.0299 28.32V11.71M13.4699 1.15002H14.6604C15.025 1.15002 15.3748 1.29489 15.6326 1.55275L23.6272 9.5473C23.885 9.80516 24.0299 10.1549 24.0299 10.5196V11.71M13.4699 1.15002V8.96002C13.4699 10.4788 １4.70１１ １１．７１ １６．２１９９ １１．７１H２４．０２９９"
        stroke={color}
        strokeWidth="2.3"
      />
    </svg>
  );
}

export default SideBarVideogalleryIcon;
